import { getLocationDetails } from '../components/LocationHelper';
import StickyNav from '../components/StickyNav';

document.addEventListener('DOMContentLoaded', () => {
    // Sticky nav init
    StickyNav().init();

    const zipCodeInput = document.getElementById('contact-zip_code') as HTMLInputElement | null;
    if (zipCodeInput) {
        // Set a character limit
        const characterLimit = 5; // Example limit for US zip codes

        // Attach the 'input' event listener
        zipCodeInput.addEventListener('input', () => {
            const zipCodeValue = zipCodeInput.value.trim();

            // Check if the value meets the character limit
            if (zipCodeValue.length >= characterLimit) {
                getLocationDetails();
            }
        });

        // Also attach 'focusout' event in case of manual entry
        zipCodeInput.addEventListener('focusout', () => {
            const zipCodeValue = zipCodeInput.value.trim();

            // Check if the value meets the character limit
            if (zipCodeValue.length >= characterLimit) {
                getLocationDetails();
            }
        });
    }

    const contactUsTab = document.getElementById('js-contact-us-tabs');
    const emailContent = document.getElementById('js-contact-us-content');
    const detailsContent = document.getElementById('js-contact-us-location-details');
    if (contactUsTab && emailContent && detailsContent) {
        const btns = contactUsTab.querySelectorAll<HTMLButtonElement>('.js-btn-contact-us-nav');

        btns.forEach((btn) => {
            btn.addEventListener('click', () => {
                const _targetId = btn.dataset.target;

                btns.forEach(button => {
                    button.classList.remove('active'); // Remove the active class from all buttons
                });

                btn.classList.add('active');

                if (_targetId) {
                    switch (_targetId) {
                        case 'form':
                            emailContent.classList.add('active');
                            detailsContent.classList.remove('active');
                            break;
                        case 'details':
                            emailContent.classList.remove('active');
                            detailsContent.classList.add('active');
                            break;
                    }
                }
            });
        });
    }
});
